import '../GerenciamentoTurmas/GerenciamentoTurmas.css'
import React, { useState, useEffect } from 'react';
import { FormGroup, Table, Button, Label, Tooltip, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { PlusCircleFill, ArrowLeftCircleFill, Search, DashCircleFill, Bell } from 'react-bootstrap-icons';
import RegistroEntradaSaida from '../ListaRegistroAlunos/ListaRegistroAlunos';
import axios from 'axios';



const Motoristas = ({ token, deParaUnidades }) => {
    const [pesquisaPorCpf, setPesquisaPorCpf] = useState(false);
    const [pesquisaPorNome, setPesquisaPorNome] = useState(false);
    const [pesquisaPorEmpresa, setPesquisaPorEmpresa] = useState(false);
    const [mainPage, setMainPage] = useState(true);
    const [pesquisaPorEmpresaNome, setPesquisaPorEmpresaNome] = useState(false);
    const [cpfPesquisa, setCpfPesquisa] = useState();
    const [listaAlunos, setListaAlunos] = useState([]);
    const [listaMotoristas, setListaMotoristas] = useState([]);
    const [cameraMode, setCameraMode] = useState('ENTRADA');
    const [modalRegistro, setModalRegistro] = useState();
    const [statusLeitura, setStatusLeitura] = useState(true);
    const [nomePesquisa, setNomePesquisa] = useState();
    const [nomeEmpresaPesquisa, setNomeEmpresaPesquisa] = useState();
    const [nomeEmpresaSelecionada, setNomeEmpresaSelecionada] = useState();
    const [listaEmpresas, setListaEmpresas] = useState([]);
    const [listaMotoristasBackup, setListaMotoristasBackup] = useState();
    const [modalidade, setModalidade] = useState('ENTRADA');
    const [alunosSelecionados, setAlunosSelecionados] = useState();
    const [motoristaSelecionado, setMotoristaSelecionado] = useState();

    const username = process.env.REACT_APP_ANJO_BACKEND_USER
    const password = process.env.REACT_APP_ANJO_BACKEND_PSW

    const togglePesquisaPorCpf = () => setPesquisaPorCpf(!pesquisaPorCpf);
    const togglePesquisaPorNome = () => setPesquisaPorNome(!pesquisaPorNome);
    const togglePesquisaPorEmpresa = () => setPesquisaPorEmpresa(!pesquisaPorEmpresa);
    const togglePesquisaPorEmpresaNome = () => setPesquisaPorEmpresaNome(!pesquisaPorEmpresaNome);
    const toggleMainPage = () => setMainPage(!mainPage);

    const fillMotoristaList = async () => {
        const response = await axios.get("motorista/getTodosPorUnidade/" + token.usuario.departamento.id.codfilial, {
            auth: {
                username,
                password
            }
        })
        localStorage.setItem('listaMotoristas', JSON.stringify(response.data));
        setListaMotoristasBackup(response.data);
        setListaMotoristas(response.data);
    }

    useEffect(() => {
        fillMotoristaList();
    }, []);

    const handlePesquisaPorCpf = () => {
        toggleMainPage();
        togglePesquisaPorCpf();
    }

    const handlePesquisaPorNome = () => {
        toggleMainPage();
        togglePesquisaPorNome();
    }

    const handlePesquisaPorEmpresa = () => {
        toggleMainPage();
        togglePesquisaPorEmpresa();
    }

    const handleModalRegistro = () => {
        setModalRegistro(!modalRegistro);
    }

    const hanldePesquisaPorEmpresaNome = () => {
        togglePesquisaPorEmpresa();
        togglePesquisaPorEmpresaNome();
    }

    const handleSelecaoAlunos = (alunosSelected) => {
        setAlunosSelecionados(alunosSelected);
    }

    const handleCpfCnpjChange = (event) => {
        // Get only the numbers from the data input
        let data = event.target.value.replace(/\D/g, "");
        // Checking data length to define if it is cpf or cnpj
        if (data.length > 11) {
            // It's cnpj
            let cnpj = `${data.substr(0, 2)}.${data.substr(2, 3)}.${data.substr(5, 3)}/`;
            if (data.length > 12)
                cnpj += `${data.substr(8, 4)}-${data.substr(12, 2)}`;
            else
                cnpj += data.substr(8);
            // Pass formatting for the data
            data = cnpj;
        } else {
            // It's cpf
            let cpf = "";
            let parts = Math.ceil(data.length / 3);
            for (let i = 0; i < parts; i++) {
                if (i === 3) {
                    cpf += `-${data.substr(i * 3)}`;
                    break;
                }
                cpf += `${i !== 0 ? "." : ""}${data.substr(i * 3, 3)}`;
            }
            // Pass formatting for the data
            data = cpf;
        }
        return data;
    };

    const renderlistaMotoristas = () => {
        let renderedList = [];
        for (let motorista of listaMotoristas) {
            renderedList.push(renderMotoristaSingle(motorista));
        }
        return renderedList;
    }

    const renderMotoristaSingle = (motorista) => {
        return (
            <div className="tabelaItem" onClick={() => handleSelecaoMotorista(motorista)}>
                <h8 className="tabelaComponent">
                    {"Nome: " + motorista["nome"] + " (CPF: " + motorista["cpf"] + ") "}
                </h8>
            </div>
        );
    }

    const renderlistaEmpresas = () => {
        let renderedList = [];
        for (let empresa of listaEmpresas) {
            renderedList.push(renderEmpresaSingle(empresa));
        }
        return renderedList;
    }

    const renderEmpresaSingle = (empresa) => {
        return (
            <div className="tabelaItem" onClick={() => handleSelecaoEmpresa(empresa)}>
                <h8 className="tabelaComponent">
                    {"Nome: " + empresa["nome"] + " (CNPJ: " + empresa["cnpj"] + ") "}
                </h8>
            </div>
        );
    }

    const handleBuscarMotoristaPorCpf = async () => {
        const response = await axios.get("motorista/buscar/porCpf/" + cpfPesquisa,
            {
                auth: {
                    username,
                    password
                }
            });
        setListaMotoristas(response.data);
    }

    const handleBuscarMotoristaPorNome = async () => {
        const response = await axios.get("motorista/buscar/porNome/" + nomePesquisa,
            {
                auth: {
                    username,
                    password
                }
            });
        setListaMotoristas(response.data);
    }

    const handleSelecaoMotorista = async (motorista) => {
        let cpfMotorista = motorista.cpf;
        setMotoristaSelecionado(motorista);
        if (modalidade === 'ENTRADA') {
            const response = await axios.get("motorista/entrada/" + cpfMotorista,
                {
                    auth: {
                        username,
                        password
                    }
                });
            setListaAlunos(response.data);
            handleModalRegistro();
        } else {
            const response = await axios.get("motorista/saida/" + cpfMotorista,
                {
                    auth: {
                        username,
                        password
                    }
                });
            setListaAlunos(response.data);
            handleModalRegistro();
        }
        
    }

    const handleBuscarEmpresas = async () => {
        const response = await axios.get("cadastroEmpresa/buscarEmpresa/porNome/" + nomeEmpresaPesquisa,
            {
                auth: {
                    username,
                    password
                }
            });
        setListaEmpresas(response.data);
    }

    const handleSelecaoEmpresa = async (empresa) => {
        let idEMpresa = empresa.uuid;
        const response = await axios.get("motorista/buscar/porIdEmpresa/" + idEMpresa,
            {
                auth: {
                    username,
                    password
                }
            });
        setListaMotoristas(response.data);
        setListaMotoristasBackup(response.data);
        setNomeEmpresaSelecionada(empresa.nome);
        hanldePesquisaPorEmpresaNome();
    }

    const handleStatusLeitura = () => {
        setStatusLeitura(!statusLeitura);
    }

    const handleMarcarRegistroMultiple = async (listaALunosMarcar) => {
        let matriculaFuncionario = token["usuario"]["matricula"];
        handleStatusLeitura();
        if (modalidade === 'ENTRADA') {
            const registroEntrada =
                await axios.post('aluno/marcar/entradaMultiple/' + matriculaFuncionario,
                    listaALunosMarcar,
                    {
                        auth: {
                            username,
                            password
                        }
                    });
            setModalRegistro(false);
            window.location.reload();
        } else {
            const registroSaida =
                await axios.post('aluno/marcar/saidaMultiple/' + matriculaFuncionario,
                    listaALunosMarcar,
                    {
                        auth: {
                            username,
                            password
                        }
                    });
            handleStatusLeitura();
            setModalRegistro(false);
            window.location.reload();
        }
    }

    const filterList = (valorReferencia) => {
        setListaMotoristas(listaMotoristasBackup);
        if (valorReferencia) {
            let listaMotoristasMod = listaMotoristasBackup.filter(motorista => substringComparator(
                motorista.nome.toUpperCase().replaceAll(' ', ''), valorReferencia.trim().toUpperCase()));
            setListaMotoristas(listaMotoristasMod);
        }
    }

    const substringComparator = (valorBase, valorReferencia) => {
        let splitReferencia = valorReferencia.split(' ');
        let values = 0;
        for (let substring of splitReferencia) {
            if (valorBase.includes(substring)) {
                values++;
            }
        };
        return values === splitReferencia.length;
    }

    const alertarAlunos = async () => {
        let cpfMotorista = motoristaSelecionado.cpf;
        const alertaAlunos =
            await axios.post('aluno/marcar/alertaMultiple/' + cpfMotorista,
                alunosSelecionados,
                {
                    auth: {
                        username,
                        password
                    }
                });
    }

    return (
        <>
            <div>
            <h3 className="cameraModeTitle">{modalidade === 'SAIDA' ? 'SAÍDA' : 'ENTRADA'}</h3>
            <div className="posicaoLeitor">
                <div class="botoesLeituraPosicao" >
                        <Button type="button" className="cameraModeButton" onClick={() => {
                            setModalidade('ENTRADA');
                    }}>
                        ENTRADA
                    </Button>
                    <Button type="button" className="cameraModeButton" onClick={() => {
                            setModalidade('SAIDA');
                    }}>
                        SAÍDA
                    </Button>

                    </div>
            </div>
             </div>
            {mainPage &&
                <>
                    <input type="text" placeholder="Buscar por Nome" className="pesquisaRapidaTurmas"
                        onChange={(e) => filterList(e.target.value)} />
                    <FormGroup>
                        <div className="TabelaConfig">
                            <div className="TabelaGer">
                                <div className="tabelaItem">
                                    <h6 className="titulosTabelas">
                                        NOME MOTORISTA
                                    </h6>
                                    <h6 className="titulosTabelas">
                                        OPÇÕES
                                    </h6>
                                </div>
                            </div>
                        {listaMotoristas === null ? (<tr> <td> none </td></tr>) : (renderlistaMotoristas())}
                        </div>
                    </FormGroup>
                </>}

            {pesquisaPorCpf && <>
                <h2 className="titulosPaginas">Pesquisa por CPF</h2>
                <div className="pesquisaRapidaPorNomeDiv">
                <input type="text" placeholder="Buscar por CPF" className="pesquisaRapidaTurmas" value={cpfPesquisa}
                    onChange={(e) => setCpfPesquisa(handleCpfCnpjChange(e))} />
                    <Button className="searchDataButton" onClick={() => handleBuscarMotoristaPorCpf()} >
                    <Search />
                </Button>
                </div>
                <FormGroup>
                    <div className="TabelaConfig">
                        <div className="TabelaGer" >
                            <div className="tabelaItem">
                                <h6 className="titulosTabelas">
                                    MOTORISTAS
                                </h6>
                                <h6 className="titulosTabelas">
                                    OPÇÕES
                                </h6>
                            </div>
                            {listaMotoristas === null ? (<tr> <td> none </td></tr>) : (renderlistaMotoristas())}
                        </div>
                    </div>
                </FormGroup>
            </>}

            {pesquisaPorNome && <>
                <h2 className="titulosPaginas">Pesquisa por Nome</h2>
                <div className="pesquisaRapidaPorNomeDiv">
                    <input type="text" placeholder="Buscar por Nome" className="pesquisaRapidaTurmas" value={nomePesquisa}
                        onChange={(e) => setNomePesquisa(e.target.value)} />
                    <Button className="searchDataButton" onClick={() => handleBuscarMotoristaPorNome()} >
                        <Search />
                    </Button>
                </div>
                <FormGroup>
                    <div className="TabelaConfig">
                        <div className="TabelaGer" >
                            <div className="tabelaItem">
                                <h6 className="titulosTabelas">
                                    MOTORISTAS
                                </h6>
                                <h6 className="titulosTabelas">
                                    OPÇÕES
                                </h6>
                            </div>
                            {listaMotoristas === null ? (<tr> <td> none </td></tr>) : (renderlistaMotoristas())}
                        </div>
                    </div>
                </FormGroup>
            </>}

            {pesquisaPorEmpresa && <>
                <h2 className="titulosPaginas">Pesquisa por Empresa</h2>
                <div className="pesquisaRapidaPorNomeDiv">
                    <input type="text" placeholder="Buscar por Empresa" className="pesquisaRapidaTurmas" value={nomeEmpresaPesquisa}
                        onChange={(e) => setNomeEmpresaPesquisa(e.target.value)} />
                    <Button className="searchDataButton" onClick={() => handleBuscarEmpresas()} >
                        <Search />
                    </Button>
                </div>
                <FormGroup>
                    <div className="TabelaConfig">
                        <div className="TabelaGer" >
                            <div className="tabelaItem">
                                <h6 className="titulosTabelas">
                                    EMPRESAS
                                </h6>
                                <h6 className="titulosTabelas">
                                    OPÇÕES
                                </h6>
                            </div>
                            {listaEmpresas === null ? (<tr> <td> none </td></tr>) : (renderlistaEmpresas())}
                        </div>
                    </div>
                </FormGroup>
            </>}

            {pesquisaPorEmpresaNome && <>
                <h2 className="titulosPaginas">Motorista por Empresa ({nomeEmpresaSelecionada})</h2>
                <div className="pesquisaRapidaPorNomeDiv">
                    <input type="text" placeholder="Buscar por Nome" className="pesquisaRapidaTurmas"
                        onChange={(e) => filterList(e.target.value)} />
                    <Button className="searchDataButton" onClick={() => handleBuscarMotoristaPorNome()} >
                        <Search />
                    </Button>
                </div>
                <FormGroup>
                    <div className="TabelaConfig">
                        <div className="TabelaGer" >
                            <div className="tabelaItem">
                                <h6 className="titulosTabelas">
                                    MOTORISTAS
                                </h6>
                                <h6 className="titulosTabelas">
                                    OPÇÕES
                                </h6>
                            </div>
                            {listaMotoristas === null ? (<tr> <td> none </td></tr>) : (renderlistaMotoristas())}
                        </div>
                    </div>
                </FormGroup>
            </>}

            <Modal isOpen={modalRegistro} toggle={handleModalRegistro}>
                <ModalHeader className="TabelaGer" toggle={handleModalRegistro}>
                    <div className="TopRegistro">
                    <h4>{modalidade === 'ENTRADA' ? "Registro de Entrada" : "Registro de Saida"}</h4>
                    {modalidade === 'SAIDA' ?
                        (<div><Button className="AlunoAlertButton" onClick={() => alertarAlunos()}>
                            <Bell size={20} />
                            Alertar
                        </Button></div>) :
                            ""}
                    </div>
                </ModalHeader>
                <ModalBody className="modalConfig">
                    <RegistroEntradaSaida
                        listaRegistroAlunos={listaAlunos}
                        putAlunoLista={handleMarcarRegistroMultiple}
                        putModalLeitura={handleModalRegistro}
                        cameraMode={modalidade}
                        putAlunosSelecionados={handleSelecaoAlunos}/>
                </ModalBody>
            </Modal>
            
        </>
    );
}

export default Motoristas;